/**
 *
 * MeetingParticipants
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import classNames from 'classnames';

function MeetingParticipants(props) {
  const { student, parents, row } = props;
  const className = classNames(['d-flex', row ? 'justify-content-between' : 'flex-column']);
  const parentsClass = classNames(['small', { 'text-end ms-2VideoConfer': row }]);
  if (!student || !parents) {
    return null;
  }
  const parentsStr = parents.map((o) => o.displayName).join(', ');
  return (
    <AvatarWithText src={student.avatar} align="center">
      <div className={className}>
        <span>{student.displayName}</span>
        <span className={parentsClass}>{parentsStr}</span>
      </div>
    </AvatarWithText>
  );
}

MeetingParticipants.propTypes = {
  student: PropTypes.object,
  parents: PropTypes.array,
  row: PropTypes.bool,
};

export default MeetingParticipants;
